// OurTeam.js
import React from 'react';
import { motion } from 'framer-motion';

const OurTeam = () => {
  const teamMembers = [
    {
      name: 'Sarah Johnson',
      position: 'Director of International Education',
      image: 'team-1.jpg'
    },
    {
      name: 'Kanlin Wu',
      position: 'Head of Recruitment Coordination',
      image: 'team-2.jpg'
    },
    {
      name: 'Robert Smith',
      position: 'Senior Admissions Consultant',
      image: 'team-3.jpg'
    },
    {
      name: 'Ling Leung',
      position: 'Candidate Services Manager',
      image: 'team-4.jpg'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            Our Team
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-3xl mx-auto">
            Notapaths is supported by a multidisciplinary team with experience in international education, recruitment coordination, admissions support, and candidate services.
          </p>
        </motion.div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              {/* Team Member Image */}
              <div className="mb-4 overflow-hidden rounded-lg shadow-md">
                <img
                  src={require(`../../assets/team/${member.image}`)}
                  alt={member.name}
                  className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Name */}
              <h3 className="text-lg font-semibold text-[#202356] mb-2">
                {member.name}
              </h3>

              {/* Position */}
              <p className="text-sm text-gray-600 font-light">
                {member.position}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Bottom Text */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center max-w-3xl mx-auto"
        >
          <p className="text-gray-700 text-sm font-light leading-relaxed">
            Our team works collaboratively to ensure every client receives clear guidance, timely communication, and consistent support throughout their journey.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default OurTeam;
